module.exports = __webpack_public_path__ + "static/media/codepen.afed7735.svg";